<template>
  <div
    :class="{
      'default-card': true,
      'default-card_active': active,
      'default-card_modules': modules
    }"
    @click="$emit('clickCard')"
  >

    <div class="default-card__header">
      <h3 class="default-card__title">{{cardText}}</h3>
      <span class="default-card__line"></span>
    </div>
    <div class="default-card__img"></div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'DefaultCard',
  components: {
  },
  props: {
    imagePath: {
      type: String,
      default: ''
    },
    cardText: {
      type: String,
      default: 'кнопка'
    },
    active: {
      type: Boolean,
      default: false
    },
    modules: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const url = ref('url(' + props.imagePath + ')')
    return {
      url
    }
  }
}
</script>

<style lang="scss" scoped>
.default-card {
  position: relative;
  padding: 24px;
  width: 520px;
  height: 280px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
  border: 1px solid #C8C8C8 ;
  transition: 1s;
  cursor: pointer;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
  }

  &__line {
    display: block;
    flex: 1;
    height: 2px;
    background-color: #C8C8C8;
  }

  @media(any-hover: hover) {
    &:hover {
      box-shadow: 1px 1px 10px #00ABEC;
      transition: 1s;
    }
  }

  &_active {
    background-color: #00ABEC;
    border-color: transparent;
    color: #FFFFFF;
    .default-card__line {
      background-color: #FFFFFF;
    }
  }

  &__img {
    width: 100%;
    height: 87%;
    background-image: v-bind(url);
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
